import React from 'react';
import { StyledNotFoundComponent } from './StyledNotFoundComponent';

const NotFoundComponent = ({noPadding, iframeUrl, zoom}) => {

  return (
    <React.Fragment>
      {
       
          <StyledNotFoundComponent >

          </StyledNotFoundComponent>
      }
    </React.Fragment>
  );
};

NotFoundComponent.propTypes = {};

export default NotFoundComponent;
